export const types = [
    {
        id: 1,
        name: 'Normal',
        icon: '💎',
        color: 'rgb(156 163 175)',
        effectiveTo: [],
        resistedBy: ['Rock', 'Steel'],
        immunedBy: ['Ghost'],
        weakTo: ['Fight'],
        resistTo: [],
        immuneTo: ['Ghost'],
    },{
        id: 2,
        name: 'Fire',
        icon: '🔥',
        color: 'rgb(249 115 22)',
        effectiveTo: ['Steel', 'Bug', 'Ice', 'Grass'],
        resistedBy: ['Water', 'Dragon'],
        immunedBy: [],
        weakTo: ['Water', 'Ground', 'Rock'],
        resistTo: ['Fire', 'Grass', 'Ice', 'Bug', 'Steel', 'Fairy'],
        immuneTo: [],
    },{
        id: 3,
        name: 'Water',
        icon: '💧',
        color: 'rgb(59 130 246)',
        effectiveTo: ['Fire', 'Rock', 'Ground'],
        resistedBy: ['Water', 'Dragon', 'Grass'],
        immunedBy: [],
        weakTo: ['Electric', 'Grass'],
        resistTo: ['Steel', 'Water', 'Fire', 'Ice'],
        immuneTo: [],
    },{
        id: 4,
        name: 'Grass',
        icon: '🌿',
        color: 'rgb(34 197 94)',
        effectiveTo: ['Water', 'Rock', 'Ground'],
        resistedBy: ['Steel', 'Bug', 'Electric', 'Grass', 'Poison', 'Flying'],
        immunedBy: [],
        weakTo: ['Fire', 'Ice', 'Poison', 'Flying', 'Bug'],
        resistTo: ['Water', 'Grass', 'Electric', 'Ground'],
        immuneTo: [],
    },{
        id: 5,
        name: 'Electric',
        icon: '⚡',
        color: 'rgb(250 204 21)',
        effectiveTo: ['Water', 'Flying'],
        resistedBy: ['Dragon', 'Electric', 'Grass'],
        immunedBy: ['Ground'],
        weakTo: ['Ground'],
        resistTo: ['Electric', 'Flying', 'Steel'],
        immuneTo: [],
    },{
        id: 6,
        name: 'Ice',
        icon: '❄️',
        color: 'rgb(103 232 249)',
        effectiveTo: ['Dragon', 'Grass', 'Ground', 'Flying'],
        resistedBy: ['Steel', 'Water', 'Fire', 'Ice'],
        immunedBy: [],
        weakTo: ['Fire', 'Fight', 'Rock', 'Steel'],
        resistTo: ['Ice'],
        immuneTo: [],
    },{
        id: 7,
        name: 'Fight',
        icon: '🥊',
        color: 'rgb(185 28 28)',
        effectiveTo: ['Steel', 'Ice', 'Normal', 'Rock', 'Dark'],
        resistedBy: ['Bug', 'Fairy', 'Psychic', 'Poison', 'Flying'],
        immunedBy: ['Ghost'],
        weakTo: ['Flying', 'Psychic', 'Fairy'],
        resistTo: ['Bug', 'Rock', 'Dark'],
        immuneTo: [],
    },{
        id: 8,
        name: 'Poison',
        icon: '☠️',
        color: 'rgb(168 85 247)',
        effectiveTo: ['Fairy', 'Grass'],
        resistedBy: ['Ghost', 'Rock', 'Ground', 'Poison'],
        immunedBy: ['Steel'],
        weakTo: ['Ground', 'Psychic'],
        resistTo: ['Grass', 'Fight', 'Poison', 'Bug', 'Fairy'],
        immuneTo: [],
    },{
        id: 9,
        name: 'Ground',
        icon: '🗿',
        color: 'rgb(161 98 7)',
        effectiveTo: ['Steel', 'Electric', 'Fire', 'Rock', 'Poison'],
        resistedBy: ['Bug', 'Grass'],
        immunedBy: ['Flying'],
        weakTo: ['Water', 'Grass', 'Ice'],
        resistTo: ['Poison', 'Rock'],
        immuneTo: ['Electric'],
    },{
        id: 10,
        name: 'Flying',
        icon: '🌪️',
        color: 'rgb(129 140 248)',
        effectiveTo: ['Bug', 'Fight', 'Grass'],
        resistedBy: ['Steel', 'Electric', 'Rock'],
        immunedBy: [],
        weakTo: ['Electric', 'Ice', 'Rock'],
        resistTo: ['Grass', 'Fight', 'Bug'],
        immuneTo: ['Ground'],
    },{
        id: 11,
        name: 'Psychic',
        icon: '🧠',
        color: 'rgb(236 72 153)',
        effectiveTo: ['Fight', 'Poison'],
        resistedBy: ['Steel', 'Psychic'],
        immunedBy: ['Dark'],
        weakTo: ['Bug', 'Ghost', 'Dark'],
        resistTo: ['Flying', 'Psychic'],
        immuneTo: [],
    },{
        id: 12,
        name: 'Bug',
        icon: '🐞',
        color: 'rgb(132 204 22)',
        effectiveTo: ['Grass', 'Psychic', 'Dark'],
        resistedBy: ['Steel', 'Ghost', 'Fire', 'Fairy', 'Fight', 'Poison', 'Flying'],
        immunedBy: [],
        weakTo: ['Fire', 'Flying', 'Rock'],
        resistTo: ['Grass', 'Fight', 'Ground'],
        immuneTo: [],
    },{
        id: 13,
        name: 'Rock',
        icon: '⛰️',
        color: 'rgb(133 77 14)',
        effectiveTo: ['Bug', 'Fire', 'Ice', 'Flying'],
        resistedBy: ['Steel', 'Fight', 'Ground'],
        immunedBy: [],
        weakTo: ['Water', 'Grass', 'Fight', 'Ground', 'Steel'],
        resistTo: ['Normal', 'Fire', 'Poison', 'Flying'],
        immuneTo: [],
    },{
        id: 14,
        name: 'Ghost',
        icon: '👻',
        color: 'rgb(126 34 206)',
        effectiveTo: ['Ghost', 'Psychic'],
        resistedBy: ['Dark'],
        immunedBy: ['Normal'],
        weakTo: ['Ghost', 'Dark'],
        resistTo: ['Poison', 'Bug'],
        immuneTo:  ['Normal', 'Fight'],
    },{
        id: 15,
        name: 'Dragon',
        icon: '🐲',
        color: 'rgb(67 56 202)',
        effectiveTo: ['Dragon'],
        resistedBy: ['Steel'],
        immunedBy: ['Fairy'],
        weakTo: ['Ice', 'Dragon', 'Fairy'],
        resistTo: ['Fire', 'Water', 'Grass', 'Electric'],
        immuneTo: [],
    },{
        id: 16,
        name: 'Dark',
        icon: '🌙',
        color: 'rgb(31 41 55)',
        effectiveTo: ['Ghost', 'Psychic'],
        resistedBy: ['Fairy', 'Fight', 'Dark'],
        immunedBy: [],
        weakTo: ['Flying', 'Bug', 'Fairy'],
        resistTo: ['Ghost', 'Dark'],
        immuneTo: ['Psychic'],
    },{
        id: 17,
        name: 'Steel',
        icon: '🛡️',
        color: 'rgb(107 114 128)',
        effectiveTo: ['Fairy', 'Ice', 'Rock'],
        resistedBy:  ['Steel', 'Water', 'Electric', 'Fire'],
        immunedBy: [],
        weakTo: ['Fire', 'Fight', 'Ground'],
        resistTo: ['Normal', 'Grass', 'Ice', 'Flying', 'Psychic', 'Bug', 'Rock', 'Dragon', 'Steel', 'Fairy'],
        immuneTo: ['Poison'],
    },{
        id: 18,
        name: 'Fairy',
        icon: '✨',
        color: 'rgb(249 168 212)',
        effectiveTo: ['Dragon', 'Fight', 'Dark'],
        resistedBy: ['Steel', 'Fire', 'Poison'],
        immunedBy: [],
        weakTo: ['Poison', 'Steel'],
        resistTo: ['Fight', 'Bug', 'Dark'],
        immuneTo: ['Dragon'],
    }
];